import React from 'react';
import { Bolts } from './bolts';
import { Button } from './button';
import { useState } from 'react';
import { Snake } from './snake';
import { NavLink } from 'react-router-dom';

export function Game() {
  const [foodLeft, setFoodLeft] = useState(Array(15).fill(1));

  return (
    <div className="game">
      <Bolts />
      <div className="game__wrapper">
        <div className="game__window">
          {/* {!isStart && (
            <Button
              name="start-game"
              className="game__start"
              setStart={setStart}
            />
          )} */}
          <div className="game__field">
            <Snake size={240} setFoodLeft={setFoodLeft} foodLeft={foodLeft} />
          </div>
        </div>

        <div className="game__helper">
          <div className="game__instructions">
            <ul>
              <li className="game__instruction">use keyboard</li>
              <li className="game__instruction">arrows to play</li>
            </ul>

            <div className="game__arrows">
              <div className="game__arrow game__arrow_up">
                <span></span>
              </div>
              <div className="game__arrows_bottom">
                <div className="game__arrow game__arrow_left">
                  <span></span>
                </div>
                <div className="game__arrow game__arrow_down">
                  <span></span>
                </div>
                <div className="game__arrow game__arrow_right">
                  <span></span>
                </div>
              </div>
            </div>
          </div>

          <div className="game__food-left">
            <span className="game__instruction">food left</span>
          </div>
          <div className="game__food-left-items">
            <ul>
              {foodLeft.map((food, index) => {
                if (food) {
                  return <li key={index} className="game__food-left-item"></li>;
                } else {
                  return (
                    <li
                      key={index}
                      className="game__food-left-item game__food-left-item-done"
                    ></li>
                  );
                }
              })}
            </ul>
          </div>
          {/* <Button name="skip" className="game__skip" /> */}
          <NavLink className="game__skip" to="/about-me">
            skip
          </NavLink>
        </div>
      </div>
    </div>
  );
}
